import React, { useState } from 'react';
import Button from '../buttons/Button';
import RadioButton from '../buttons/RadioButton';
import { useAppContext } from '../contexts/AppContext';
import { usePopupContext } from '../contexts/PopupContext';
import { constructBurstAssessmentLink, linkOnClickHandler } from '../navigation/navigation';
import CloseButton from '../buttons/CloseButton';
import ScreenOverlay from '../../components/body/ScreenOverlay';
import { MEASURE_BY_SKILL_NAME, MEASURE_SCORE_BY_SKILL_NAME } from '../../constants/assessments';
import { PERIOD } from '../../constants/enrollment';

const getFormSelectionContent = (
    selectedProbeConfig,
    bmProbeConfig,
    altProbeConfig,
    setProbeConfigById,
) => (
    <>
        <RadioButton
            id={bmProbeConfig.id.toString()}
            key={bmProbeConfig.id.toString()}
            value={bmProbeConfig.id.toString()}
            name="Reuse the Benchmark form"
            isChecked={bmProbeConfig.id.toString() === selectedProbeConfig.id.toString()}
            onChange={e => setProbeConfigById(e.currentTarget.value)}
        />
        <RadioButton
            id={altProbeConfig.id.toString()}
            key={altProbeConfig.id.toString()}
            value={altProbeConfig.id.toString()}
            name="Use the Alternate Benchmark form instead"
            isChecked={altProbeConfig.id === selectedProbeConfig.id}
            onChange={e => setProbeConfigById(e.currentTarget.value)}
        />
    </>
);

const BurstAltFormSelectionPopup = () => {
    const { bmWindow, classId } = useAppContext();
    const {
        params: { studentId, skillName, formData },
        actions: { hideBurstAltFormSelectionPopup },
    } = usePopupContext();
    const measure = MEASURE_BY_SKILL_NAME[skillName];
    const updatedPeriod = bmWindow.period === PERIOD.SUMMER ? PERIOD.EOY : bmWindow.period;
    const params = {
        studentId,
        classeId: classId,
        period: updatedPeriod,
        measure,
    };
    const bmProbeConfig = formData.find(config => config.is_alt === false);
    const altProbeConfig = formData.find(config => config.is_alt === true);

    const [probeConfigSource, setProbeConfigSource] = useState(altProbeConfig);

    const setProbeConfigById = formId => {
        const probeConfig = formData.find(config => config.id.toString() === formId);
        setProbeConfigSource(probeConfig);
    };

    const onSubmitButtonClick = e => {
        const assessmentLink = constructBurstAssessmentLink({
            ...params,
            is_alt: probeConfigSource.is_alt ? 1 : 0,
            probeId: probeConfigSource.probeId,
        });
        hideBurstAltFormSelectionPopup();
        linkOnClickHandler(assessmentLink)(e);
    };
    return (
        <ScreenOverlay>
            <div className='dashboard-form-selection-popup-wrapper dashboard-alternative-form-popup'>
                <div className='dashboard-form-selection-popup-header'>
                    <p>Alternate Form Selection</p>
                    <CloseButton onClick={hideBurstAltFormSelectionPopup} />
                </div>
                <div className='dashboard-form-selection-popup-body'>
                    <span>
                        The {MEASURE_SCORE_BY_SKILL_NAME[skillName]} measure was invalidated. Would
                        you like to:
                    </span>
                    {getFormSelectionContent(
                        probeConfigSource,
                        bmProbeConfig,
                        altProbeConfig,
                        setProbeConfigById,
                    )}
                    <div className='dashboard-controls'>
                        <Button onClick={onSubmitButtonClick} />
                    </div>
                </div>
            </div>
        </ScreenOverlay>
    );
};

export default BurstAltFormSelectionPopup;
